<template>
  <div :class="['row-elements', sub_class, { big: is_big }]">
    <div class="container">
      <div
        class="row"
        :class="[
          stretch_image
            ? 'flex-vertical-align-stretch'
            : 'flex-vertical-align-center',
          auto_height_image ? 'auto-height-image' : '',
        ]"
      >
        <div
          :class="[
            'row-element',
            'col-l-' + text_size_d,
            'col-m-' + text_size_t,
            'col-s-' + text_size_m,
            'order-l-' + text_order_d,
            'order-m-' + text_order_t,
            'order-s-' + text_order_m,
            { 'col-hide-l': text_hide_d },
            { 'col-hide-m': text_hide_t },
            { 'col-hide-s': text_hide_m },
          ]"
        >
          <div class="content">
            <div v-html="text" />
            <a class="btn default" v-if="link_label" v-bind:href="link_url">{{
              link_label
            }}</a>
            <a
              class="btn default"
              v-if="extra_link_label"
              v-bind:href="extra_link_url"
              >{{ extra_link_label }}</a
            >

            <button
              v-if="button_video_true"
              class="btn default show-modal"
              id="show-modal"
              @click="showModal = true"
              v-html="button_video_text"
            >
              <svg
                width="13px"
                height="14px"
                viewBox="0 0 13 14"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <g
                  id="latest-deck"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <g
                    id="3-offer"
                    transform="translate(-827.000000, -1427.000000)"
                    fill="#FFFFFF"
                  >
                    <polygon
                      id="Path-2"
                      points="827 1427 827 1441.03125 839.1875 1434.03125"
                    />
                  </g>
                </g>
              </svg>
            </button>

            <modal v-if="showModal" @close="showModal = false">
              <div slot="content">
                <div class="videoWrapper">
                  <iframe
                    :src="videosrc"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>
            </modal>
          </div>
        </div>
        <div
          v-if="!is_fixed"
          :class="[
            'notched',
            { notched__enabled: image_is_notched },
            image_notched_type,
            image_notched_mobile_type,
            image_notched_position,
            image_notched_mobile_position,
            image_notched_color,
            { notched__outside: image_notched_type },
            'row-element image',
            'col-l-' + image_size_d,
            'col-m-' + image_size_t,
            'col-s-' + image_size_m,
            'order-l-' + image_order_d,
            'order-m-' + image_order_t,
            'order-s-' + image_order_m,
            { 'col-l-hide': image_hide_d },
            { 'col-m-hide': image_hide_t },
            { 'col-s-hide': image_hide_m },
          ]"
          :style="{
            'background-image': 'url( ' + image + ' )',
            'background-position': horizontal + '% ' + vertical + '%',
          }"
        >
          <div class="notched-helper"></div>
        </div>
        <div
          v-if="image_2"
          :class="[
            'row-element image',
            'col-l-' + image_size_d,
            'col-m-' + image_size_t,
            'col-s-' + image_size_m,
            'order-l-' + image_order_d,
            'order-m-' + image_order_t,
            'order-s-' + image_order_m,
            { 'col-l-hide': image_hide_d },
            { 'col-m-hide': image_hide_t },
            { 'col-s-hide': image_hide_m },
          ]"
          :style="{ 'background-image': 'url( ' + image_2 + ' )' }"
        ></div>
        <div
          v-if="image_3"
          :class="[
            'row-element image',
            'col-l-' + image_size_d,
            'col-m-' + image_size_t,
            'col-s-' + image_size_m,
            'order-l-' + image_order_d,
            'order-m-' + image_order_t,
            'order-s-' + image_order_m,
            { 'col-l-hide': image_hide_d },
            { 'col-m-hide': image_hide_t },
            { 'col-s-hide': image_hide_m },
          ]"
          :style="{ 'background-image': 'url( ' + image_3 + ' )' }"
        ></div>
        <div
          v-if="is_fixed"
          :class="[
            'row-element image',
            'col-l-' + image_size_d,
            'col-m-' + image_size_t,
            'col-s-' + image_size_m,
            'order-l-' + image_order_d,
            'order-m-' + image_order_t,
            'order-s-' + image_order_m,
            { 'col-l-hide': image_hide_d },
            { 'col-m-hide': image_hide_t },
            { 'col-s-hide': image_hide_m },
          ]"
        >
          <img :src="image" :alt="image" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from "../components/Modal.vue";
import { scroller } from "vue-scrollto/src/scrollTo";

export default {
  props: ["blockdata"],
  name: "block",
  data() {
    return {
      text: this.blockdata.text.content,
      horizontal: this.blockdata.image.position_horizontal_image,
      vertical: this.blockdata.image.position_vertical_image,
      image: this.blockdata.image.file.url,
      image_is_notched: this.blockdata.image.is_notched,
      image_notched_type: this.blockdata.image.notched_type,
      image_notched_mobile_type: this.blockdata.image.notched_mobile_type,
      image_notched_position: this.blockdata.image.notched_position,
      image_notched_mobile_position:
        this.blockdata.image.notched_mobile_position,
      image_notched_color: this.blockdata.image.notched_color,
      image_2: this.blockdata.image.extra_file_1.url,
      image_3: this.blockdata.image.extra_file_2.url,
      image_size_d: this.blockdata.image.size_d,
      image_size_t: this.blockdata.image.size_t,
      image_size_m: this.blockdata.image.size_m,
      text_size_d: this.blockdata.text.size_d,
      text_size_t: this.blockdata.text.size_t,
      text_size_m: this.blockdata.text.size_m,
      image_order_d: this.blockdata.image.order_d,
      image_order_t: this.blockdata.image.order_t,
      image_order_m: this.blockdata.image.order_m,
      text_order_d: this.blockdata.text.order_d,
      text_order_t: this.blockdata.text.order_t,
      text_order_m: this.blockdata.text.order_m,
      stretch_image: this.blockdata.image.stretch_i,
      auto_height_image: this.blockdata.image.auto_height_i,
      image_hide_d: this.blockdata.image.hide_d,
      image_hide_t: this.blockdata.image.hide_t,
      image_hide_m: this.blockdata.image.hide_m,
      text_hide_d: this.blockdata.text.hide_d,
      text_hide_t: this.blockdata.text.hide_t,
      text_hide_m: this.blockdata.text.hide_m,
      sub_class: this.blockdata.class,
      is_big: this.blockdata.image.is_big,
      is_fixed: this.blockdata.image.is_fixed,
      link_url: this.blockdata.button_link && this.blockdata.button_link.url,
      link_label:
        this.blockdata.button_link && this.blockdata.button_link.title,
      extra_link_url:
        this.blockdata.button_extra_link &&
        this.blockdata.button_extra_link.url,
      extra_link_label:
        this.blockdata.button_extra_link &&
        this.blockdata.button_extra_link.title,
      button_video_true: this.blockdata.button_video,
      button_video_text: this.blockdata.button_video_text,
      videosrc: this.blockdata.button_video,
      showModal: false,
    };
  },
  components: {
    Modal,
  },
  mounted() {
    if (this.$route.params.slug) {
      const scrollTo = scroller();
      scrollTo("#" + this.$route.params.slug);
    }
  },
};
</script>



// WEBPACK FOOTER //
// Block.vue?9fbba42a